/* MAXXING 2.0 · motion layer.
   - Scroll reveal: targets get .mx-reveal + --i (sibling index) and .is-in when ~12% visible. One-shot.
   - Count-up: .mx-ev__num / .mx-callout__stat animate the numeric part once, prefix/suffix preserved.
   - Header: .mx-scrolled on <html> after 8px so the bar can blur/tint.
   Everything is skipped when prefers-reduced-motion is set or IntersectionObserver is missing. */
(function () {
  'use strict';
  var html = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) { html.classList.remove('mx-motion'); return; }

  var TARGETS = [
    '.mx-head', '.mx-hero__copy > *', '.mx-hero__media',
    '.mx-trust__item', '.mx-steps > li', '.mx-steps__cta',
    '.mx-callout', '.mx-range__tabs', '.mx-range__grid > li',
    '.mx-it__media', '.mx-it__copy', '.mx-ev__item', '.mx-ev + .mx-caption',
    '.mx-fp__media', '.mx-fp__copy', '.mx-rv', '.mx-cmp__row', '.mx-faq details',
    '.mx-footer__brand', '.mx-footer__col', '.mx-footer__news',
    '.product__media-wrapper', '.product__info-wrapper', '.collection .card-wrapper'
  ].join(',');

  function prep(root) {
    var els = root.querySelectorAll(TARGETS);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.classList.contains('mx-reveal')) continue;
      el.classList.add('mx-reveal');
      // stagger by position among revealed siblings (cap at 8 so long grids don't lag)
      var n = 0, s = el;
      while ((s = s.previousElementSibling) && n < 8) { if (s.classList.contains('mx-reveal')) n++; }
      el.style.setProperty('--i', n);
      io.observe(el);
    }
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (!e.isIntersecting) continue;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
      var nums = e.target.matches('.mx-ev__num, .mx-callout__stat') ? [e.target] : e.target.querySelectorAll('.mx-ev__num, .mx-callout__stat');
      for (var j = 0; j < nums.length; j++) countUp(nums[j]);
    }
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });

  function countUp(el) {
    if (el.dataset.mxCounted) return;
    el.dataset.mxCounted = '1';
    var raw = el.textContent.trim();
    var m = raw.match(/^([^\d]*)(\d[\d,]*)(\.\d+)?(.*)$/);
    if (!m) return;
    var prefix = m[1], intPart = m[2].replace(/,/g, ''), dec = m[3] || '', suffix = m[4];
    var target = parseFloat(intPart + dec);
    var decimals = dec ? dec.length - 1 : 0;
    var useComma = m[2].indexOf(',') > -1;
    var start = null, dur = 900;
    el.style.fontVariantNumeric = 'tabular-nums';
    function fmt(v) {
      var s = v.toFixed(decimals);
      if (useComma) { var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); s = p.join('.'); }
      return prefix + s + suffix;
    }
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
      el.textContent = fmt(target * eased);
      if (t < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }


  // Cart drawer: Shrine prints "Discounts: $0.00) $0.00)" when KaChing discounts are all zero — hide only that case.
  function zeroDiscounts() {
    document.querySelectorAll('.cart-drawer__footer__discounts').forEach(function (el) {
      var t = (el.textContent || '').replace(/\s+/g, ' ');
      var amounts = t.match(/[\d.,]+/g) || [];
      var allZero = amounts.length > 0 && amounts.every(function (a) { return parseFloat(a.replace(/,/g, '')) === 0; });
      el.classList.toggle('mx-zero-discounts', allZero);
    });
  }
  zeroDiscounts();
  var drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
  if (drawer && 'MutationObserver' in window) new MutationObserver(zeroDiscounts).observe(drawer, { childList: true, subtree: true });

  function onScroll() { html.classList.toggle('mx-scrolled', window.scrollY > 8); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  function init() { prep(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor: re-prep when sections load/reorder.
  document.addEventListener('shopify:section:load', function (e) { prep(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var els = e.target.querySelectorAll('.mx-reveal');
    for (var i = 0; i < els.length; i++) io.unobserve(els[i]);
  });
  // Range tabs: content swapped by hidden attr; re-reveal the newly shown panel.
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('.mx-range__tabs [role="tab"]');
    if (!tab) return;
    var panel = document.getElementById(tab.getAttribute('aria-controls'));
    if (!panel) return;
    var items = panel.querySelectorAll('.mx-reveal');
    for (var i = 0; i < items.length; i++) { items[i].classList.remove('is-in'); }
    requestAnimationFrame(function () { for (var i = 0; i < items.length; i++) items[i].classList.add('is-in'); });
  });
})();

/* MAXXING 2.0 · AJAX add-to-cart for mx- section "Add" buttons.
   Forms marked data-mx-ajax add via fetch and keep the shopper on the page (no /cart redirect),
   so they can keep adding. The header cart count + drawer contents refresh silently; the button
   flashes a confirmation. Progressive enhancement: if fetch is unavailable the form POSTs normally. */
(function () {
  'use strict';
  if (!window.fetch || !window.routes || !window.routes.cart_add_url) return;
  var parser = new DOMParser();

  function inner(html, sel) {
    try {
      var el = parser.parseFromString(html, 'text/html').querySelector(sel);
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }

  function requestedSections() {
    var ids = [];
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (document.querySelector('cart-drawer') && document.getElementById('CartDrawer')) ids.push('cart-drawer');
    return ids;
  }

  function applySections(res) {
    if (!res || !res.sections) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && res.sections['cart-icon-bubble']) {
      var b = inner(res.sections['cart-icon-bubble'], '.shopify-section');
      if (b !== null) bubble.innerHTML = b;
    }
    var drawer = document.getElementById('CartDrawer');
    if (drawer && res.sections['cart-drawer']) {
      var d = inner(res.sections['cart-drawer'], '#CartDrawer');
      if (d !== null) {
        drawer.innerHTML = d;
        var dEl = document.querySelector('cart-drawer');
        if (dEl) dEl.classList.remove('is-empty');
      }
    }
  }

  function flash(btn, text) {
    if (!btn) return;
    if (btn.dataset.mxOriginal === undefined) btn.dataset.mxOriginal = btn.textContent;
    clearTimeout(btn._mxTimer);
    btn.textContent = text;
    btn._mxTimer = setTimeout(function () {
      btn.textContent = btn.dataset.mxOriginal;
    }, 1600);
  }

  // Serialize adds so rapid clicks apply their Section Rendering responses in submit order —
  // the last-applied DOM then reflects the final cart, never a stale earlier response.
  var chain = Promise.resolve();

  function addToCart(body, btn) {
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          flash(btn, 'Unavailable');
          return;
        }
        applySections(res.data);
        flash(btn, 'Added ✓');
        document.dispatchEvent(new CustomEvent('mx:cart:added', { detail: res.data }));
      })
      .catch(function () { /* network error: leave the shopper on the page, no redirect */ })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    // Opt-in marker may sit on the <form> or on its submit control — accept either so a
    // mid-propagation mix of cached section/JS versions still adds via fetch instead of redirecting.
    if (!form.hasAttribute('data-mx-ajax') && !form.querySelector('button[data-mx-ajax], [type="submit"][data-mx-ajax]')) return;
    e.preventDefault();

    // Reflect loading/added state on the actual submit control.
    var btn = e.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    if (btn) btn.setAttribute('aria-busy', 'true');

    var body = new FormData(form);
    var sections = requestedSections();
    if (sections.length) {
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
    }

    chain = chain.then(function () { return addToCart(body, btn); });
  });
})();
